
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M32.75 20.63c-.29-1.31-1-2.57-2.56-2.57-1.87 0-2.68 2-2.7 3.58-.02 1.58.79 3.47 2.59 3.57 1.6.09 2.38-1.23 2.67-2.59.096-.325.143-.662.14-1 .007-.335-.04-.67-.14-.99zm-1.65 1.16a1.55 1.55 0 01-.91.28 1.63 1.63 0 01-.91-.28.689.689 0 01-.18-.16.752.752 0 01.09-.09 1.53 1.53 0 01.89-.32 1.61 1.61 0 01.94.21c.09.058.174.125.25.2a.651.651 0 01-.17.16z"}}),_c('path',{attrs:{"d":"M29.5 40.51V26.8c0-1.89 1.38-1.87 1.38 0v13.71c0 1.89-1.38 1.87-1.38 0z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M30.19 7c12.693 0 21.563 10.515 22.17 22.565.018.144.026.306.02.485v.02c.006.187-.002.355-.022.505-.614 12.051-9.482 22.555-22.168 22.555C17.64 53.13 8 42.34 8 30.07S17.61 7 30.19 7zM51 30.07A20.8 20.8 0 0130.19 50C19.37 50 9.38 41.2 9.38 30.07c0-10.87 9.56-19.57 20.13-19.9A20.79 20.79 0 0151 30.07z"}})])
          )
        }
      }
    